module.exports = __webpack_public_path__ + "static/media/edge_icon.65f09e65.png";